import { cookie } from '@pmi/pmi-iqos-shared-react'

export default class Market {
  constructor(api) {
    this.api = api
  }

  getOrderStatus = async opts => {
    const res = await this.api.get('/market/order/status', {
      ...opts,
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      mock: this.api.getMock('getMarketOrderStatus')
    })
    cookie.setToken(res.auth_token)
    return res
  }

  confirmOrder = async data => {
    const res = await this.api.post('/market/order/confirm', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      mock: this.api.getMock('marketConfirmOrder'),
      data
    })
    cookie.setToken(res.auth_token)
    return res
  }
}
